import { useEffect, useRef, useState } from "react";
import { Asset } from "../../models/Asset"; // Adjust path as needed
import { setupAssetPreview } from "../EditAsset/Asset3DPreview";
import * as THREE from "three";


interface AssetPreviewProps {
  asset: Asset;
  modelBlob: Blob | null;
  setModelTree?: (modelScene: any) => void;
}

export function AssetPreview({ asset, modelBlob, setModelTree }: AssetPreviewProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [model, setModel] = useState<THREE.Object3D | null>(null);
  const [blob, setBlob] = useState<Blob | null>(null);
  const [cleanup, setCleanup] = useState<() => void>(() => () => {});
  useEffect(() => {
    return () => {
      if (cleanup) {
        console.log("Cleaning up asset preview");
        cleanup();
      }
    };
  }, []);
  useEffect(() => {
    if (containerRef.current && asset && modelBlob && modelBlob.size > 0) {
      if (!model || blob !== modelBlob) {
        setBlob(modelBlob);
        const { cleanup } = setupAssetPreview(
          containerRef.current,
          asset,
          modelBlob,
          model => {
            setModel(model);
            if (setModelTree) {
              setModelTree(model);
            }
          }
        );
        setCleanup(() => cleanup);
      } else if (asset && model) {
        (model as any).asset = asset;
        // console.log("Updating asset preview: ", asset);
        // model.scale.set(asset.scale, asset.scale, asset.scale);
        // model.position.set(asset.position[0], asset.position[1], asset.position[2]);
        // model.rotation.set(asset.rotation[0], asset.rotation[1], asset.rotation[2]);
        // model.updateMatrixWorld();
      }
    }
  }, [asset, modelBlob, setModelTree]);

  return <div ref={containerRef} style={{ width: "100%", height: "100%" }} />;
}
